import React from 'react';
import '../index.css';
import LinkedInLogo from '../Images/Linkedin.png';
import GitHubLogo from '../Images/Github.png';

function Contact() {
  return (
    <main className={`container mx-auto px-4 py-6 ${'fade-in'}`}>
    <div className="container mx-auto p-4">
      <h1 className="text-4xl font-semibold text-indigo-600 mb-4 animate-fade-in-up text-center underline">
        Send Me A Message!
      </h1>
      <form
        target="_blank"
        action="https://formsubmit.co/e99b8f33b6d2e120b649a084b5550cd4"
        method="POST"
        className="max-w-lg mx-auto mb-8"
      >
        <div className="mb-4">
          <div className="flex mb-2">
            <div className="w-1/2 mr-2">
              <input
                type="text"
                name="name"
                className="border border-gray-300 rounded px-4 py-2 w-full"
                placeholder="Full Name"
                required
              />
            </div>
            <div className="w-1/2 ml-2">
              <input
                type="email"
                name="email"
                className="border border-gray-300 rounded px-4 py-2 w-full"
                placeholder="Email Address"
                required
              />
            </div>
          </div>
        </div>
        <div className="mb-4">
          <textarea
            placeholder="Your Message"
            name="message"
            className="border border-gray-300 rounded px-4 py-2 w-full h-32 resize-none"
            required
          ></textarea>
        </div>
        <button
          type="submit"
          className="bg-indigo-600 text-white px-4 py-2 rounded w-full"
        >
          Submit!
        </button>
      </form>
      <div className="flex flex-col items-center">
        <p className="text-2xl font-semibold text-gray-600 mb-4">You can also find me on:</p>
        <div className="flex">
          <a href="https://www.linkedin.com/in/abinand-n/" target="_blank" rel="noopener noreferrer">
            <img
              src={LinkedInLogo}
              alt="LinkedIn"
              className="w-16 h-16 mx-4"
            />
          </a>
          <a href="https://github.com/abinandn1" target="_blank" rel="noopener noreferrer">
            <img src={GitHubLogo} alt="GitHub" className="w-16 h-16 mx-4" />
          </a>
        </div>
      </div>
    </div>
    </main>
  );
}

export default Contact;
